exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main__container {\n  display: -ms-flexbox;\n  display: flex; }\n\n.main__navigation {\n  border-right: 1px solid #ddd;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  height: 100vh; }\n\n.main__content {\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/shared/components/Main/index.scss
// module id = 243
// module chunks = 0